import { AbstractItemSelector } from './item-selector';
import { ItemCardSelectionInfoKind, SingleItemCardSelectionInfo, SafelySelectableMenuItem } from '@/models';

type SingleItemSelectorArgs = boolean | undefined;

export class SingleItemSelector extends AbstractItemSelector<SingleItemSelectorArgs> {
  getSelectionKind() {
    return ItemCardSelectionInfoKind.Single;
  }

  selectItem(item: SafelySelectableMenuItem<SingleItemCardSelectionInfo>, args: SingleItemSelectorArgs) {
    item.selectionInfo.selected = args === undefined ? true : !!args;

    return true;
  }

  deselectItem(item: SafelySelectableMenuItem<SingleItemCardSelectionInfo>) {
    item.selectionInfo.selected = false;
  }

  isItemSelected(item: SafelySelectableMenuItem<SingleItemCardSelectionInfo>) {
    return item.selectionInfo.selected;
  }

  isDeselecting(item: SafelySelectableMenuItem<SingleItemCardSelectionInfo>, args: SingleItemSelectorArgs) {
    return !!!args;
  }

  getQuantityAfterSelection(item: SafelySelectableMenuItem<SingleItemCardSelectionInfo>, args: SingleItemSelectorArgs) {
    return args ? 1 : 0;
  }

  getItemQuantity(item: SafelySelectableMenuItem<SingleItemCardSelectionInfo>) {
    return item.selectionInfo.selected ? 1 : 0;
  }

  getEffectiveItemQuantity(item: SafelySelectableMenuItem<SingleItemCardSelectionInfo>) {
    return item.selectionInfo.selected ? 1 : 0;
  }

  getMaxQuantity(item: SafelySelectableMenuItem<SingleItemCardSelectionInfo>) {
    return 1;
  }

  copySelectionTo(target: SafelySelectableMenuItem<SingleItemCardSelectionInfo>, src: SafelySelectableMenuItem<SingleItemCardSelectionInfo>) {
    target.selectionInfo.selected = src.selectionInfo.selected;

    return true;
  }
}
